module.exports = __webpack_public_path__ + "img/packages/1.bccaa0.png";